import Env from '@/utils/env';

export const isGrassfish = () => {
  return Env.getEnv('VITE_THEME') === 'grassfish';
};
